import {
	type Deal,
	useCheckoutFormState,
} from "../../hooks/useCheckoutFormState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";
import { Label } from "../ui/label";
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";

export type SelectDealProps = {
	disabled: boolean;
};
export const SelectDeal: React.FC<SelectDealProps> = (props) => {
	const componentName = "deal";
	const checkoutFormState = useCheckoutFormState();
	const translate = useTranslate();

	const items: Deal[] = [];
	items.push({
		DealId: "-",
		Deal: `(${translate("New Job")})`,
	});
	items.push(...(checkoutFormState.get().deals ?? []));

	const caption = translate("Job");
	const selectedValue = checkoutFormState.get().dealIdValue ?? "";
	const selectedDealLabel =
		items.find((item) => item.DealId === selectedValue)?.Deal ?? "";
	//if (checkoutFormState.get().warehouseIdValue && (checkoutFormState.get().lookupwarehouse?.length ?? 0)) {
	//    selectedValue = checkoutFormState.get().dealIdValue ?? '';
	//}

	return (
		<div className="w-full">
			<Label htmlFor={`${componentName}-select`} className="mb-1">
				{caption}
			</Label>
			<Select
				id={`${componentName}-select`}
				disabled={props.disabled}
				onValueChange={async (value) => {
					const dealid = value || "";
					return Promise.resolve().then(() => {
						checkoutFormState.setSelectedDealId(dealid);
						checkoutFormState.setJobName("");
					});
				}}
				value={selectedValue}
			>
				<SelectTrigger className="h-8 w-full">
					<SelectValue>{selectedDealLabel}</SelectValue>
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{items.map((deal) => {
							return (
								<SelectItem key={deal.DealId} value={deal.DealId}>
									{deal.Deal}
								</SelectItem>
							);
						})}
					</SelectGroup>
				</SelectContent>
			</Select>
		</div>
	);
};
